module.exports = __webpack_public_path__ + "static/img/img_118016.1d268f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_118016.png
// module id = GnBD
// module chunks = 1